let getAccessTokenSilently: (() => Promise<string> | null) | null = null;
let loginWithRedirect: ((options?: { appState?: { returnTo?: string } }) => Promise<void>) | null = null;

interface TokenManager {
	getAccessTokenSilently: () => (() => Promise<string> | null) | null;
	setAccessTokenSilently: (func: () => Promise<string>) => void;
	getLoginWithRedirect: () => ((options?: { appState?: { returnTo?: string } }) => Promise<void>) | null;
	setLoginWithRedirect: (func: (options?: { appState?: { returnTo?: string } }) => Promise<void>) => void;
}

const tokenManager: TokenManager = {
	getAccessTokenSilently: () => getAccessTokenSilently,
	setAccessTokenSilently: (func: () => Promise<string>) => {
		getAccessTokenSilently = func;
	},
	getLoginWithRedirect: () => loginWithRedirect,
	setLoginWithRedirect: (func: () => Promise<void>) => {
		loginWithRedirect = func;
	},
};

export default tokenManager;
